import { useTranslations } from "use-intl";

import { Card, CardContent, CardHeader } from "@lawline/ui/components/card";

import { useAuth } from "@platform/auth/context";

// The server lets only a role that can create keys approve a connection. The page explains that to
// every other role above the steps.
export function ConnectFlow() {
	const t = useTranslations("aiApps.flow");
	const tConnect = useTranslations("mcpConnect");
	const { can } = useAuth();

	return (
		<Card>
			<CardHeader>
				<h2 className="text-base font-medium">{t("title")}</h2>
			</CardHeader>
			<CardContent className="flex flex-col gap-3">
				<ol className="flex list-decimal flex-col gap-1 pl-5">
					<li>{t("signIn")}</li>
					<li>{t("organization")}</li>
					<li>{t("approve", { page: tConnect("title") })}</li>
				</ol>
				{can({ apiKey: ["create"] }) ? <p className="font-medium">{t("canApprove")}</p> : null}
				<p className="text-muted-foreground">{t("billing")}</p>
				<p className="text-muted-foreground">{t("lapse")}</p>
			</CardContent>
		</Card>
	);
}
